import DRAWER from 'common/constants/drawer/Drawer.constants';
import { useGetNotes } from 'services/hooks/notes';
import { NotesDrawerTabTitleProps } from './NotesDrawerTabTitle.props';

/**
 * Renders the Notes drawer tab title with count. Owns the notes query so the count
 * is available without selecting the tab; only runs when mounted (when notes tab exists).
 */
const NotesDrawerTabTitle = ({ pageType, pageTypeKey, pageTypeId, notesFallback }: NotesDrawerTabTitleProps) => {
  const { data } = useGetNotes({ pageType, pageTypeKey, pageTypeId });
  const count = data?.length ?? notesFallback?.length ?? 0;
  return <>{`${DRAWER.TABS.NOTES} (${count})`}</>;
};

export default NotesDrawerTabTitle;
